import parse from "html-react-parser";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import config from "config";
import ToastHtmlComponent from "../../Reusable/ToastHtmlComponent/ToastHtmlComponent.js";
import Form from "components/Reusable/Form/Form.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";

import "./JumboCodesRecovery.scss";

const JumboCodesRecovery = () => {
  const { getPageText, replaceKeywordsInText, getTextByKey } = useContent();
  const { addToast } = useToasts();
  const replaceBaseUrl = (textConst) => {
    let temp = textConst;
    if (textConst.includes("#BaseUrl#")) {
      temp = temp.replace("#BaseUrl#", config.baseurl + "/");
    }
    return temp;
  };

  const sendMailToRecovery = async (body) => {
    const response = await apiRequest(
      "UploadCodes",
      "ClientSendReconstructedCodesToMail",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data === "Good") {
        addToast(getTextByKey("recovery-codes-success") + " " + body.Email, {
          appearance: "success",
        });
      } else if ((response.data = "NotExists")) {
        addToast(getTextByKey("recovery-codes-empty-list"), {
          appearance: "error",
        });
      } else if (response.data === "Bad") {
        addToast(getTextByKey("empty-email-recover-codes"), {
          appearance: "error",
        });
      } else {
        let errText = getTextByKey("api-error");
        errText = errText.replace("#ERRORNUM#", response.data);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        errText = errText.replace("#SYSMAIL#", config.supportmail);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        addToast(<ToastHtmlComponent htmlStr={errText} />, {
          appearance: "error",
        });
      }
    } else {
      let errText = getTextByKey("api-error");
      errText = errText.replace("#ERRORNUM#", response.data);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      errText = errText.replace("#SYSMAIL#", config.supportmail);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      addToast(<ToastHtmlComponent htmlStr={errText} />, {
        appearance: "error",
      });
    }
  };

  return (
    <div className="full-page recover-full-page">
      <div className="page-container recover-password">
        <div className="title-page">
          <h1>
            {getPageText().Display_title
              ? parse(getPageText().Display_title)
              : null}
          </h1>
          <div className="title-divider"></div>{" "}
        </div>
        <div className="main-page">
          {getPageText().TextBox
            ? parse(replaceKeywordsInText(getPageText().TextBox))
            : null}
          <Form
            fields={{
              Email: {
                fieldKey: "Email",
                element: "input",
                type: "email",
                title: "UserName",
                placeholder: "recovery-codes-email",
                label: "login-user-email-label",
                validation: {
                  required: true,
                  invalidMessage: "invalid-email-text",
                  reg: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                },
              },
            }}
            fieldsProps={{ label: "hidden" }}
            onSubmit={sendMailToRecovery}
            submitProps={{
              title: getTextByKey("recovery-codes-button"),
            }}
          />
          <div className="login-users-div">
            {getPageText().TextBox2 &&
              parse(replaceBaseUrl(getPageText().TextBox2))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JumboCodesRecovery;
